import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { useUserStore } from "@/stores/useUserStore"
import { API_Data_Self_Response } from "@/interfaces/api/self/api_response_types"
import { useEffect } from "react"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getSelf } from "../requests/user"
import Cookies from "js-cookie"

type ProfilesOptions = Omit<
  UseQueryOptions<API_Data_Self_Response, API_Error, API_Data_Self_Response, ['self']>,
  'queryKey' | 'queryFn'
>

export const useSelf = (options?: ProfilesOptions) => {
  const { userId, setUser } = useUserStore()

  const query = useQuery<API_Data_Self_Response, API_Error, API_Data_Self_Response, ['self']>({
    queryKey: ['self'],
    retry: false,
    queryFn: getSelf,
    ...options
  })

  useEffect(() => {
    if (!Cookies.get("token")) return
    if (!query.isSuccess) return 
    if (query.data.id === userId) return
    
    setUser(query.data.id)
  }, [query.data?.id, userId])

  return query
}